import React, { useEffect } from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import { IMAGE_API } from '../../../resources';

// export default function HojaDocument(receta, logoHospital, nombreHospital, datosPaciente) {

// PARENT: Expediente

export default function HojaDocument({ nombreHospital, logoHospital, receta, datosPaciente }) {

    const { createdAt, peso, imc, dosis, inicio, intermedio, termino, observaciones, aplicacion, hora_inicio, hora_termino, medico_tratante, phq9, gad7, columbia } = receta;

    const { name, medicos_asignados, num_expediente } = datosPaciente;

    useEffect(() => {
        // console.log('hoja enf props', props)
        console.log('hoja enf ', receta)
        // console.log('hoja enf logoHospital', logoHospital)
        // console.log('hoja enf nombreHospital', nombreHospital)
        console.log('hoja enf datosPaciente', datosPaciente)
    }, [])


    const styles = StyleSheet.create({
        page: {
            flexDirection: 'column',
            backgroundColor: '#ffffff',
            padding: 30,
            fontSize: 11,
        },
        header: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 10,
        },
        logo: {
            width: 90,
        },
        headerRight: {
            fontSize: 8,
            textAlign: 'right',
        },
        title: {
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 'bold',
            marginVertical: 12,
        },
        fieldRow: {
            flexDirection: 'row',
            marginBottom: 8,
            gap: 10,
        },
        fieldText: {
            fontSize: 11,
        },
        underline: {
            borderBottomWidth: 1,
            borderBottomColor: '#000',
            flex: 1,
            marginLeft: 4,
        },
        table: {
            display: "table",
            width: "auto",
            borderStyle: "solid",
            borderWidth: 1,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            marginTop: 10,
        },
        tableRow: {
            flexDirection: "row",
        },
        tableCol: {
            width: "14.285%",
            borderStyle: "solid",
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0,
            minHeight: 22,
            justifyContent: 'center',
        },
        tableColHeader: {
            width: "14.285%",
            borderStyle: "solid",
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0,
            backgroundColor: '#f5f5f5',
            minHeight: 28,
            justifyContent: 'center',
        },
        tableCell: {
            textAlign: 'center',
            fontSize: 9,
            padding: 2,
        },
        observationsTitle: {
            fontSize: 11,
            fontWeight: 'bold',
            marginTop: 14,
            marginBottom: 6,
        },
        observationsBox: {
            flexDirection: 'row',
            borderWidth: 1,
            borderColor: '#000',
            minHeight: 120,
        },
        observationsLeft: {
            flex: 1,
            padding: 6,
            borderRightWidth: 1,
            borderRightColor: '#000',
        },
        observationsRight: {
            width: 150,
            padding: 6,
            justifyContent: 'flex-start',
            gap: 12,
        },
        signatureSection: {
            textAlign: 'center',
            marginTop: 20,
            fontSize: 11,
        },
        signatureLine: {
            width: '60%',
            borderBottomWidth: 1,
            borderBottomColor: '#000',
            alignSelf: 'center',
            marginTop: 30,
            marginBottom: 4,
        },
        footer: {
            fontSize: 7,
            textAlign: 'center',
            marginTop: 'auto',
            paddingTop: 10,
            color: '#555',
        },
    });

    // Create Document Component
    function Receta() {
        return <Document>
            <Page size="A4" style={styles.page}>

                {/* Header: logo left, doc code right */}
                <View style={styles.header}>
                    <Image style={styles.logo} src={IMAGE_API + logoHospital} />
                    <View>
                        <Text style={styles.headerRight}>R-CDL-028 Hoja de enfermería Ketamina</Text>
                        <Text style={styles.headerRight}>Ed 0 {new Date(createdAt).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })}</Text>
                    </View>
                </View>

                {/* Title */}
                <Text style={styles.title}>HOJA DE ENFERMERÍA KETAMINA</Text>

                {/* FECHA */}
                <View style={[styles.fieldRow, { justifyContent: 'center' }]}>
                    <Text style={styles.fieldText}>FECHA</Text>
                    <View style={[styles.underline, { maxWidth: 180 }]}>
                        <Text style={styles.fieldText}>{new Date(createdAt).toLocaleDateString('es-MX')}</Text>
                    </View>
                </View>

                {/* NOMBRE + NUM. DE EXP. */}
                <View style={styles.fieldRow}>
                    <Text style={styles.fieldText}>NOMBRE</Text>
                    <View style={styles.underline}>
                        <Text style={styles.fieldText}>{name}</Text>
                    </View>
                    <Text style={styles.fieldText}>NUM. DE EXP.</Text>
                    <View style={[styles.underline, { maxWidth: 100 }]}>
                        <Text style={styles.fieldText}>{num_expediente || ''}</Text>
                    </View>
                </View>

                {/* APLICACIÓN NO. + REF. NO. + CÓDIGO */}
                <View style={styles.fieldRow}>
                    <Text style={styles.fieldText}>APLICACIÓN NO.</Text>
                    <View style={[styles.underline, { maxWidth: 80 }]}>
                        <Text style={styles.fieldText}>{aplicacion + 1}</Text>
                    </View>
                    <Text style={styles.fieldText}>REF. NO.</Text>
                    <View style={[styles.underline, { maxWidth: 80 }]}>
                        <Text style={styles.fieldText}></Text>
                    </View>
                    <Text style={styles.fieldText}>CÓDIGO</Text>
                    <View style={[styles.underline, { maxWidth: 80 }]}>
                        <Text style={styles.fieldText}></Text>
                    </View>
                </View>

                {/* PESO + IMC + DOSIS */}
                <View style={styles.fieldRow}>
                    <Text style={styles.fieldText}>PESO</Text>
                    <View style={[styles.underline, { maxWidth: 100 }]}>
                        <Text style={styles.fieldText}>{peso} kg</Text>
                    </View>
                    <Text style={styles.fieldText}>IMC</Text>
                    <View style={[styles.underline, { maxWidth: 100 }]}>
                        <Text style={styles.fieldText}>{imc || ''}</Text>
                    </View>
                    <Text style={styles.fieldText}>DOSIS</Text>
                    <View style={styles.underline}>
                        <Text style={styles.fieldText}>{dosis}</Text>
                    </View>
                </View>

                {/* HORA DE INICIO + HORA DE TÉRMINO */}
                <View style={styles.fieldRow}>
                    <Text style={styles.fieldText}>HORA DE INICIO</Text>
                    <View style={[styles.underline, { maxWidth: 120 }]}>
                        <Text style={styles.fieldText}>{hora_inicio ? new Date(hora_inicio).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : ''}</Text>
                    </View>
                    <Text style={styles.fieldText}>HORA DE TÉRMINO</Text>
                    <View style={styles.underline}>
                        <Text style={styles.fieldText}>{hora_termino ? new Date(hora_termino).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : ''}</Text>
                    </View>
                </View>

                {/* MÉDICO TRATANTE */}
                <View style={styles.fieldRow}>
                    <Text style={styles.fieldText}>MÉDICO TRATANTE</Text>
                    <View style={styles.underline}>
                        <Text style={styles.fieldText}>{medico_tratante || (medicos_asignados?.length > 0 ? medicos_asignados.map(m => m.name).join(', ') : '')}</Text>
                    </View>
                </View>

                {/* SIGNOS VITALES TABLE */}
                <View style={styles.table}>
                    {/* Header row */}
                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeader}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>SIGNOS{'\n'}VITALES</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>HORA</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>TEMP.</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>F. CARD.</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>F. RESP.</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>T/A</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>Sat O₂</Text>
                        </View>
                    </View>
                    {/* INICIO */}
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>INICIO</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{inicio?.hora ? new Date(inicio.hora).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{inicio?.temperatura ? `${inicio.temperatura}°` : ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{inicio?.frecuencia_cardiaca || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{inicio?.frecuencia_respiratoria || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{inicio?.presion_arterial || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{inicio?.saturacion_oxigeno || ''}</Text>
                        </View>
                    </View>
                    {/* INTERMEDIO */}
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>INTERMEDIO</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{intermedio?.hora ? new Date(intermedio.hora).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{intermedio?.temperatura ? `${intermedio.temperatura}°` : ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{intermedio?.frecuencia_cardiaca || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{intermedio?.frecuencia_respiratoria || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{intermedio?.presion_arterial || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{intermedio?.saturacion_oxigeno || ''}</Text>
                        </View>
                    </View>
                    {/* TÉRMINO */}
                    <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                            <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>TÉRMINO</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{termino?.hora ? new Date(termino.hora).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{termino?.temperatura ? `${termino.temperatura}°` : ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{termino?.frecuencia_cardiaca || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{termino?.frecuencia_respiratoria || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{termino?.presion_arterial || ''}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>{termino?.saturacion_oxigeno || ''}</Text>
                        </View>
                    </View>
                </View>

                {/* OBSERVACIONES */}
                <Text style={styles.observationsTitle}>PROCEDIMIENTOS REALIZADOS, SIGNOS Y SÍNTOMAS (OBSERVACIONES DE ENFERMERÍA)</Text>

                <View style={styles.observationsBox}>
                    <View style={styles.observationsLeft}>
                        <Text style={{ fontSize: 10 }}>{observaciones}</Text>
                    </View>
                    <View style={styles.observationsRight}>
                        <Text style={{ fontSize: 11, fontWeight: 'bold' }}>PHQ-9: {phq9 || ''}</Text>
                        <Text style={{ fontSize: 11, fontWeight: 'bold' }}>GAD-7: {gad7 || ''}</Text>
                        <Text style={{ fontSize: 11, fontWeight: 'bold' }}>COLUMBIA: {columbia || ''}</Text>
                    </View>
                </View>

                {/* ENF. RESPONSABLE */}
                <Text style={styles.signatureSection}>ENF. RESPONSABLE</Text>
                <View style={styles.signatureLine}></View>
                <Text style={[styles.signatureSection, { fontWeight: 'bold', fontSize: 13 }]}>NOMBRE Y FIRMA</Text>

                {/* Footer */}
                <Text style={styles.footer}>
                    Este documento es propiedad de CIDERALT y no puede ser distribuido externamente sin la autorización escrita de los socios propietarios
                </Text>

            </Page>
        </Document>

    }
    return <div>
        <PDFViewer height={700} width={550}>
            <Receta />
        </PDFViewer>
    </div>

}